import __ from "src/utils/Translations";
import translateFields from "src/utils/Translations/translateFields";

export const rootBreadcrumb = { title: "Firma", link: "/company" };

export const getCompanyBaseBreadcrumbs = (companyId, companyName) => [
  translateFields(rootBreadcrumb, ["title"]),
  { title: `${__("Lista firm")}`, link: "/company/list" },
  {
    title: `${__("Zarządzanie firmą")} ${companyName} (${companyId})`,
    link: `/company/edit/${companyId}`,
  },
];

export const getBankEditPath = (companyId, bankId) =>
  `/company/edit/${companyId}/banks/management/${bankId}`;

/** Bank edit page opened on the one-time charges tab. */
export const getSingleChargesListPath = (companyId, bankId) =>
  `${getBankEditPath(companyId, bankId)}#single_charges`;

export const getSingleChargesNewPath = (companyId, bankId) =>
  `/company/edit/${companyId}/banks/management/${bankId}/single-charges/new`;

export const SINGLE_CHARGES_NEW_ROUTE =
  "edit/:companyId/banks/management/:bankId/single-charges/new";

/**
 * Opens the "add charge" form pre-filled as a copy of an existing one-time
 * charge definition (type=definition) or charge template (type=template).
 */
export const getSingleChargesClonePath = (
  companyId,
  bankId,
  chargeId,
  type = "template"
) =>
  `${getSingleChargesNewPath(
    companyId,
    bankId
  )}?cloneFrom=${chargeId}&type=${type}`;

export const getSingleChargesViewPath = (
  companyId,
  bankId,
  chargeId,
  type = "template"
) =>
  `/company/edit/${companyId}/banks/management/${bankId}/single-charges/${chargeId}/view?type=${type}`;

export const SINGLE_CHARGES_VIEW_ROUTE =
  "edit/:companyId/banks/management/:bankId/single-charges/:chargeId/view";

export const getSingleChargesEditPath = (
  companyId,
  bankId,
  chargeId,
  type = "template"
) =>
  `/company/edit/${companyId}/banks/management/${bankId}/single-charges/${chargeId}/edit?type=${type}`;

export const SINGLE_CHARGES_EDIT_ROUTE =
  "edit/:companyId/banks/management/:bankId/single-charges/:chargeId/edit";

/** Bank edit page opened on the cyclic charges tab. */
export const getCyclicChargesListPath = (companyId, bankId) =>
  `${getBankEditPath(companyId, bankId)}#cyclic_charges`;

export const getCyclicChargesNewPath = (companyId, bankId) =>
  `/company/edit/${companyId}/banks/management/${bankId}/cyclic-charges/new`;

/**
 * Opens the "add cyclic charge" form pre-filled as a copy of an existing
 * cyclic charge definition. Uses the existing "new" route – the query param
 * does not require a new route.
 */
export const getCyclicChargesClonePath = (companyId, bankId, chargeId) =>
  `${getCyclicChargesNewPath(companyId, bankId)}?cloneFrom=${chargeId}`;

export const CYCLIC_CHARGES_NEW_ROUTE =
  "edit/:companyId/banks/management/:bankId/cyclic-charges/new";

export const getCyclicChargesViewPath = (companyId, bankId, chargeId) =>
  `/company/edit/${companyId}/banks/management/${bankId}/cyclic-charges/${chargeId}/view`;

export const CYCLIC_CHARGES_VIEW_ROUTE =
  "edit/:companyId/banks/management/:bankId/cyclic-charges/:chargeId/view";

export const getCyclicChargesEditPath = (companyId, bankId, chargeId) =>
  `/company/edit/${companyId}/banks/management/${bankId}/cyclic-charges/${chargeId}/edit`;

export const CYCLIC_CHARGES_EDIT_ROUTE =
  "edit/:companyId/banks/management/:bankId/cyclic-charges/:chargeId/edit";
